import { CurrentSelectedMethodType } from '../types';

type GetCurrentSelectedMethodTypeParams = {
  isAddGiftCardMethodSelected: boolean;
  isAddNewCardMethodSelected: boolean;
  isAdyenIdealMethodSelected?: boolean;
  isPaycometPaypalMethodSelected?: boolean;
  isPaycometSodexoMethodSelected?: string;
  isPaycometChequeGourmetMethodSelected?: string;
  selectedMethodExist: boolean;
};

function getCurrentSelectedMethodType({
  isAddGiftCardMethodSelected,
  isAddNewCardMethodSelected,
  isAdyenIdealMethodSelected,
  isPaycometPaypalMethodSelected,
  isPaycometSodexoMethodSelected,
  isPaycometChequeGourmetMethodSelected,
  selectedMethodExist,
}: GetCurrentSelectedMethodTypeParams): CurrentSelectedMethodType {
  let currentSelectedMethodType = CurrentSelectedMethodType.ADD_NEW_PAYMENT_METHOD;
  if (isAddGiftCardMethodSelected) {
    currentSelectedMethodType = CurrentSelectedMethodType.ADD_NEW_GIFT_CARD;
  }
  if (isAddNewCardMethodSelected) {
    currentSelectedMethodType = CurrentSelectedMethodType.ADD_NEW_CARD;
  }
  if (isPaycometPaypalMethodSelected) {
    currentSelectedMethodType = CurrentSelectedMethodType.ADD_NEW_PAYMENT_PAYPAL;
  }
  if (isPaycometSodexoMethodSelected === 'card') {
    currentSelectedMethodType = CurrentSelectedMethodType.ADD_NEW_PAYMENT_SODEXO;
  }
  if (isPaycometChequeGourmetMethodSelected === 'card') {
    currentSelectedMethodType = CurrentSelectedMethodType.ADD_NEW_PAYMENT_CHEQUE_GOURMET;
  }
  if (isAdyenIdealMethodSelected) {
    currentSelectedMethodType = CurrentSelectedMethodType.PAY_VIA_IDEAL;
  }
  if (selectedMethodExist) {
    currentSelectedMethodType = CurrentSelectedMethodType.SELECTED_PAYMENT_METHOD_OPTION;
  }
  return currentSelectedMethodType;
}

export default getCurrentSelectedMethodType;
